// Retrieve value of modalGateConfirmation cookie
var modalGateConfirmation = sessionStorage.getItem('modalGateConfirmation');
// Retrieve value of modalDelayedCTA cookie
var modalDelayedCTA = sessionStorage.getItem('modalDelayedCTA');

//$(document).ready(function ($) {    commented out because there's no need to wait for "document ready", we already have everything we need rendered

	// if modalGateConfirmation cookie is null, show .modal-gate
    if ($(".modal-gate").length && !$(".modal-gate").hasClass("delayed") && modalGateConfirmation == null) {
        if (getParameterByName("confirmation") == "true") {
            sessionStorage.setItem('modalGateConfirmation', 1);
        } else {
            setTimeout(function () {
                $('.modal-gate').modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $('#skip-link').attr('aria-hidden', 'true');
                $('#site-header').attr('aria-hidden', 'true');
                $('#content').attr('aria-hidden', 'true');
                $('#footer').attr('aria-hidden', 'true');

                $('.modal-gate').attr('aria-hidden', 'false');
            }, 0);
        }
    }

    // if modalDelayedCTA cookie is null, show .modal-gate

    if ($(".modal-gate.delayed").length && modalDelayedCTA != "1") {
        setTimeout(function () {
            $('.modal-gate').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#skip-link').attr('aria-hidden', 'true');
            $('#site-header').attr('aria-hidden', 'true');
            $('#content').attr('aria-hidden', 'true');
            $('#footer').attr('aria-hidden', 'true');

            $('.modal-gate').attr('aria-hidden', 'false');
            $(".modal-gate").hasClass("delayed") ? $('.modal-open').css('overflow', 'auto') : '';
            $(".modal-gate").hasClass("delayed") ? $('.modal-backdrop.show').css('display', 'none') : '';

        }, $(".modal-gate").hasClass("delayed") ? 60000 : 0);
    }
//});

// set modalGateConfirmation cookie value to 1 when .modal-gate-confirm button is clicked
$('button.modal-gate-confirm').click(function(event) {
	if (modalGateConfirmation == null) {
		sessionStorage.setItem('modalGateConfirmation', 1);
    }

	//window.location = '#';
    //window.scroll(0,0);

	// unhide content on .modal-gate hide
	$('#skip-link').attr('aria-hidden', 'false');
  	$('#site-header').attr( 'aria-hidden','false');
	$('#content').attr( 'aria-hidden','false');
	$('#footer').attr( 'aria-hidden','false');

	$('.modal-gate').attr('aria-hidden', 'true');
});


function attachClickEventToExtLinks() {
    // when ext-link is clicked show appropriate modal and set value of the link in that modal to the href value of the clicked link
    $('a[class*="ext-link"]:not("[class*=\'ext-link-out\']"), div[class*="ext-link"]:not("[class*=\'ext-link-out\']")').off("click.extlink").on("click.extlink", function (event) {
        var extLinkSuffix = getClassSuffix(this, "ext-link");
        if (extLinkSuffix === "DOES_NOT_CONTAIN_CLASS") return;

        event.preventDefault();
        var tag = $(this).get(0).tagName.toLowerCase();
        var extLinkValue = "";
        if (tag == "div") {
            extLinkValue = $(this).data("url");
        }
        else {
            extLinkValue = $(this).attr("href");
        }

        $("a.ext-link-out" + extLinkSuffix).attr("href", extLinkValue);
        $('.modal-leaving-site' + extLinkSuffix).modal();
        $('#skip-link').attr('aria-hidden', 'true');
        $('#site-header').attr('aria-hidden', 'true');
        $('#content').attr('aria-hidden', 'true');
        $('#footer').attr('aria-hidden', 'true');

        $('.modal-leaving-site' + extLinkSuffix).attr('aria-hidden', 'false');
    });
}

attachClickEventToExtLinks();

$('a[class*="ext-link-out"]').click(function (event) {
    var extLinkSuffix = getClassSuffix(this, "ext-link-out");
    if (extLinkSuffix === "DOES_NOT_CONTAIN_CLASS") return;
    $('.modal-leaving-site' + extLinkSuffix).modal('hide');
});

$('.modal-gate.delayed button, .modal-gate.delayed .delayed-cta-link').click(function (e) {
    sessionStorage.setItem('modalDelayedCTA', 1);
    $('.modal-gate.delayed').modal('hide');
});

// unhide content on .modal-leaving-site hide
$('[class*="modal-leaving-site"]').on('hidden.bs.modal', function (e) {
    $('#skip-link').attr('aria-hidden', 'false');
    $('#site-header').attr('aria-hidden', 'false');
    $('#content').attr('aria-hidden', 'false');
    $('#footer').attr('aria-hidden', 'false');

    $('[class*="modal-leaving-site"]').attr('aria-hidden', 'true');
});

function getClassSuffix(element, classPrefix) {
    var allClassesString = $(element).attr("class");
    if (allClassesString) {
        var allClassesList = allClassesString.split(/\s+/);
        var ourClass = allClassesList.find(function (e) {
            return e.startsWith(classPrefix);
        });
        if (ourClass) return ourClass.replace(classPrefix, "");
    }
    return "DOES_NOT_CONTAIN_CLASS";
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}